module.exports = __webpack_public_path__ + "img/2-7-1.0936aa3e.png";